// jQuery と jquery-effects-core は WordPress 側で wp_enqueue_script により読み込む
// WordPress 同梱の jQuery は noConflict モードで `$` を解放するため、ここで再エイリアスする
window.$ = window.jQuery;

import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleNews from './routes/single-news';

const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  singleNews,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
